// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useRegistrarServiceRequests } from '@hooks/queries/registry/onboarding/useRegistrarServiceRequests';
import { RegistrarServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';

export const useInboundRegistrarServiceRequests = () => {
  const { party } = useParties();
  const transform = (data: TemplateContract<RegistrarServiceRequest>[]): number => {
    return data.filter((r) => r.payload.registrar === party).length;
  };
  return useRegistrarServiceRequests(transform);
};
